import { useState as b, useRef as cr, useCallback as o } from "react";
import B from "./index346.mjs";
import { filterErrors as N } from "./index347.mjs";
import { clearListState as z } from "./index348.mjs";
import { shouldValidateOnChange as A } from "./index349.mjs";
import { setPath as lr } from "./index350.mjs";
import { validateFieldValue as D } from "./index351.mjs";
import { reorderPath as ur } from "./index352.mjs";
import { removePath as fr } from "./index353.mjs";
import { insertPath as ar } from "./index354.mjs";
import { validateValues as G } from "./index355.mjs";
import { getStatus as H } from "./index356.mjs";
import { getPath as P } from "./index357.mjs";
import { getInputOnChange as mr } from "./index358.mjs";
var dr = Object.defineProperty, vr = Object.defineProperties, _r = Object.getOwnPropertyDescriptors, J = Object.getOwnPropertySymbols, Pr = Object.prototype.hasOwnProperty, yr = Object.prototype.propertyIsEnumerable, K = (i, n, c) => n in i ? dr(i, n, { enumerable: !0, configurable: !0, writable: !0, value: c }) : i[n] = c, d = (i, n) => {
  for (var c in n || (n = {}))
    Pr.call(n, c) && K(i, c, n[c]);
  if (J)
    for (var c of J(n))
      yr.call(n, c) && K(i, c, n[c]);
  return i;
}, j = (i, n) => vr(i, _r(n));
function Rr({
  initialValues: i = {},
  initialErrors: n = {},
  initialDirty: c = {},
  initialTouched: M = {},
  clearInputErrorOnChange: C = !0,
  validateInputOnChange: Q = !1,
  validateInputOnBlur: U = !1,
  transformValues: W = (y) => y,
  validate: u
} = {}) {
  const [y, O] = b(M), [V, w] = b(c), [s, a] = b(i), [L, p] = b(N(n)), F = cr(i), X = (r) => {
    F.current = r;
  }, R = o(() => O({}), []), T = (r) => {
    X(r || s), w({});
  }, I = o((r) => p((e) => N(typeof r == "function" ? r(e) : r)), []), S = o(() => p({}), []), k = o(() => {
    a(i), S(), T(i), R();
  }, []), v = o((r, e) => I((t) => j(d({}, t), { [r]: e })), []), g = o((r) => I((e) => {
    if (typeof r != "string")
      return e;
    const t = d({}, e);
    return delete t[r], t;
  }), []), E = o((r) => w((e) => {
    if (typeof r != "string")
      return e;
    const t = z(r, e);
    return delete t[r], t;
  }), []), x = o((r, e) => {
    const t = A(r, Q);
    E(r), O((l) => j(d({}, l), { [r]: !0 })), a((l) => {
      const _ = lr(r, e, l);
      if (t) {
        const f = D(r, u, _);
        f.hasError ? v(r, f.error) : g(r);
      }
      return _;
    }), !t && C && v(r, null);
  }, []), Y = o((r) => {
    a((e) => {
      const t = typeof r == "function" ? r(e) : r;
      return d(d({}, e), t);
    }), C && S();
  }, []), Z = o((r, e) => {
    E(r), a((t) => ur(r, e, t));
  }, []), $ = o((r, e) => {
    E(r), a((t) => fr(r, e, t)), p((t) => z(r, t));
  }, []), h = o((r, e, t) => {
    E(r), a((l) => ar(r, e, t, l));
  }, []), q = o(() => {
    const r = G(u, s);
    return p(r.errors), r;
  }, [s, u]), rr = o((r) => {
    const e = D(r, u, s);
    return e.hasError ? v(r, e.error) : g(r), e;
  }, [s, u]), er = (r, { type: e = "input", withError: t = e === "input", withFocus: l = !0 } = {}) => {
    const f = { onChange: mr((m) => x(r, m)) };
    return t && (f.error = L[r]), e === "checkbox" ? f.checked = P(r, s) : f.value = P(r, s), l && (f.onFocus = () => O((m) => j(d({}, m), { [r]: !0 })), f.onBlur = () => {
      if (A(r, U)) {
        const m = D(r, u, s);
        m.hasError ? v(r, m.error) : g(r);
      }
    }), f;
  }, tr = (r, e) => (t) => {
    t == null || t.preventDefault();
    const l = q();
    l.hasErrors ? e == null || e(l.errors, s, t) : r(W(s), t);
  }, or = o((r) => {
    r.preventDefault(), k();
  }, []), sr = (r) => {
    if (r) {
      const t = P(r, V);
      if (typeof t == "boolean")
        return t;
      const l = P(r, s), _ = P(r, F.current);
      return !B(l, _);
    }
    return Object.keys(V).length > 0 ? H(V) : !B(s, F.current);
  }, nr = o((r) => H(y, r), [y]), ir = o((r) => r ? !D(r, u, s).hasError : !G(u, s).hasErrors, [s, u]);
  return {
    values: s,
    errors: L,
    setValues: Y,
    setErrors: I,
    setFieldValue: x,
    setFieldError: v,
    clearFieldError: g,
    clearErrors: S,
    reset: k,
    validate: q,
    validateField: rr,
    reorderListItem: Z,
    removeListItem: $,
    insertListItem: h,
    getInputProps: er,
    onSubmit: tr,
    onReset: or,
    isDirty: sr,
    isTouched: nr,
    setTouched: O,
    setDirty: w,
    resetTouched: R,
    resetDirty: T,
    isValid: ir
  };
}
export {
  Rr as useForm
};
